import { Fragment } from 'react';

import { Badge } from '@playbooks/ui/components/badge';
import { FadIcon } from '@playbooks/ui/components/icon';

const CollectionBadges = ({ collection, variant = 'library' }) => {
	const published = collection.published || (collection.visibility === 'public' && collection.publishDate);
	const staffPick = collection.featured || collection.editorial?.featured;

	return (
		<Fragment>
			{variant === 'library' && published && (
				<Badge variant='succeeded'>
					<FadIcon icon='globe' />
					In marketplace
				</Badge>
			)}
			{variant === 'marketplace' && staffPick && (
				<Badge variant='succeeded'>
					<FadIcon icon='badge-check' />
					Staff pick
				</Badge>
			)}
		</Fragment>
	);
};
export { CollectionBadges };
